'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Glyph = require('./Glyph');

var _Glyph2 = _interopRequireDefault(_Glyph);

var ALERT_TYPES = ['error', 'info', 'success', 'warning', 'help'];
var ICON_MAP = {
    error: 'icon-critical-small',
    info: 'icon-info-small',
    success: 'icon-circled-checkmark-small',
    warning: 'icon-attention-small',
    help: 'icon-info-small'
};

var Alert = (function (_React$Component) {
    _inherits(Alert, _React$Component);

    function Alert() {
        _classCallCheck(this, Alert);

        _get(Object.getPrototypeOf(Alert.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Alert, [{
        key: 'getCloseIcon',
        value: function getCloseIcon() {
            var _this = this;

            var closeIcon = null;

            if (this.props.dismissable) {
                closeIcon = _react2['default'].createElement(_Glyph2['default'], {
                    size: 'small',
                    icon: 'icon-close-small',
                    className: 'close',
                    onClick: function () {
                        if (_this.props.onDismiss) {
                            _this.props.onDismiss(_this);
                        }
                    }
                });
            }
            return closeIcon;
        }
    }, {
        key: 'render',
        value: function render() {
            var componentClass = (0, _classnames2['default'])('Alert', 'Alert--' + this.props.type, this.props.className),
                glyphType = {
                help: 'primary',
                info: 'default'
            };

            return _react2['default'].createElement(
                'div',
                { id: this.props.id, className: componentClass },
                _react2['default'].createElement(_Glyph2['default'], {
                    size: 'small',
                    type: glyphType[this.props.type] || this.props.type,
                    icon: ICON_MAP[this.props.type]
                }),
                _react2['default'].createElement(
                    'div',
                    { className: 'msg' },
                    this.props.children
                ),
                this.getCloseIcon()
            );
        }
    }]);

    return Alert;
})(_react2['default'].Component);

Alert.propTypes = {
    children: _propTypes2['default'].node.isRequired,
    className: _propTypes2['default'].string,
    dismissable: _propTypes2['default'].bool,
    id: _propTypes2['default'].string,
    onDismiss: _propTypes2['default'].func,
    type: _propTypes2['default'].oneOf(ALERT_TYPES).isRequired
};

Alert.defaultProps = {
    dismissable: false,
    errors: []
};

module.exports = Alert;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Alert.js
// module id = 272
// module chunks = 0